import React from "react";
import { Mars, Venus } from "lucide-react";

export const C = { male: "#0EA5E9", female: "#EC4899", unset: "#CBD5E1", teal: "#2EB4AC", amber: "#F59E0B" };
export const axis = { tick: { fill: "#64748B", fontSize: 11 }, axisLine: false, tickLine: false };
export const tip = { contentStyle: { fontSize: 12, borderRadius: 8, border: "1px solid #E2E8F0" }, cursor: { fill: "rgba(46,180,172,0.06)" } };

export const Section = ({ no, title, sub, children, testid }) => (
    <section className="space-y-4" data-testid={testid}>
        <div className="flex items-baseline gap-3">
            <span className="font-mono text-xs font-bold text-[#2EB4AC]">{no}</span>
            <h2 className="font-heading text-lg font-bold text-slate-900">{title}</h2>
            {sub && <span className="text-xs text-slate-500">{sub}</span>}
        </div>
        {children}
    </section>
);

export const Card = ({ title, hint, children, className = "", testid }) => (
    <div className={`bg-white border border-slate-200 rounded-lg shadow-sm p-4 ${className}`} data-testid={testid}>
        {title && (
            <div className="flex items-center justify-between mb-3 gap-2">
                <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500 font-semibold">{title}</div>
                {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
            </div>
        )}
        {children}
    </div>
);

export const Kpi = ({ label, value, sub, tone = "text-slate-900", icon, testid }) => (
    <div className="bg-white border border-slate-200 rounded-lg shadow-sm px-4 py-3" data-testid={testid}>
        <div className="flex items-center gap-1.5 text-[11px] text-slate-500 font-medium">{icon}{label}</div>
        <div className={`text-2xl font-bold tabular-nums mt-0.5 ${tone}`}>{value}</div>
        {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
);

export const GenderLegend = ({ unset = true }) => (
    <div className="flex items-center gap-3 text-[11px] text-slate-500">
        <span className="inline-flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: C.male }} />Male</span>
        <span className="inline-flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: C.female }} />Female</span>
        {unset && <span className="inline-flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: C.unset }} />Not set</span>}
    </div>
);

export const GIcon = ({ g, className = "h-3 w-3" }) =>
    g === "male" ? <Mars className={`${className} text-sky-600`} /> : g === "female" ? <Venus className={`${className} text-pink-600`} /> : null;

export const Empty = ({ children = "Not enough data yet." }) => <div className="text-xs text-slate-400 py-6 text-center">{children}</div>;

export const fmtDate = (d) => d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });

export const PersonLine = ({ r, right, onOpen }) => (
    <button onClick={() => onOpen(r.p.user_id)} className="w-full flex items-center gap-2.5 py-1.5 text-left hover:bg-slate-50 rounded px-1 -mx-1" data-testid={`milestone-person-${r.p.user_id}`}>
        <span className="h-7 w-7 rounded-full bg-teal-50 text-[#25908A] border border-teal-100 text-xs font-semibold flex items-center justify-center overflow-hidden flex-shrink-0">
            {r.p.picture ? <img src={r.p.picture} alt="" className="h-full w-full object-cover" /> : (r.p.name || "?")[0]}
        </span>
        <span className="min-w-0 flex-1">
            <span className="text-sm text-slate-900 truncate flex items-center gap-1">{r.p.name}<GIcon g={r.p._g} /></span>
            <span className="block text-[11px] text-slate-500 truncate">{r.p.designation || "—"}</span>
        </span>
        <span className="text-xs text-slate-600 whitespace-nowrap">{right}</span>
    </button>
);
